import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import RequestedDocument from "../../entity/emergency/RequestedDocument";
import useEmergencyInterventionDemo
    from "../../component/private/intervention/emergency/demo/useEmergencyInterventionDemoServer";
import axios from "axios";

const SERVICE = "service-emergency";
const ENTITY = "requested_documents";

/**
 * @rule-checker exclude
 * @returns {{select(): (null|*), exec(): (undefined|*|void|null|boolean|undefined)}|null|*|void|boolean|{select(): (null|*), exec(boolean=): (undefined|*|void|null|boolean|undefined)}|Promise<boolean|undefined>|{findOneById(*): {select(): (null|*), exec(boolean=): (undefined|*|void|null|boolean|undefined)}, findAllByInterventionId(*): {select(): (null|*), exec(): (undefined|*|void|null|boolean|undefined)}, getFile: function(*): Promise<any|null|undefined>, update(*, *, *): Promise<undefined|*|void|null|boolean>}}
 */
export default function () {
    const {findOneBy, findAllBy, update} = useApi();
    const state = useSelector;
    const newInstance = data => new RequestedDocument(data);
    const demo = useEmergencyInterventionDemo();

    return {
        findOneById(id) {
            return {
                select() {
                    const result = state(state => state.api?.emergency?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                exec(useCache = true) {
                    if (demo.isLockRequest()) {
                        return demo.handleRequest("GET", SERVICE, ENTITY, "id", id);
                    }

                    findOneBy(SERVICE, ENTITY, "id", id, newInstance, "application_v7", false, useCache);
                }
            }
        },
        findAllByInterventionId(id) {
            return {
                select() {
                    const result = state(state => state.api?.emergency?.[ENTITY]?.filter(r => r?.getInterventionId() == id));

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    if (demo.isLockRequest()) {
                        return demo.handleRequest("GET", SERVICE, ENTITY, "intervention_id", id);
                    }

                    findAllBy(SERVICE, ENTITY, "intervention_id", id, newInstance, "application_v7");
                }
            }
        },
        getFile: async id => {
            try {
                const response = await axios.get(process.env.REACT_APP_API_URL + `/service-emergency/application_v7/requested_documents/${id}/file`);

                return response.data;
            } catch (e) {
                console.log(e);
                return null;
            }
        },
        async update(id, property, payload) {
            if (demo.isLockRequest()) {
                return demo.handleRequest("PATCH", SERVICE, ENTITY, "document", payload, id);
            }

            return update(SERVICE, ENTITY, id, property, payload, newInstance, "application_v7");
        }
    }
}